// hooks/useHook.ts
import { useMemo } from "react";
import { divideByKey } from "../utils";

// Novo Hook de autenticação
import { useAuth } from "../context/AuthContext";

// ---------------------------------------------------------
// PROFILE  (carrega o usuário autenticado do useAuth)
// ---------------------------------------------------------
export const useProfile = () => {
  const { user, loading } = useAuth();

  return {
    userProfile: user,
    loading,
  };
};

// ---------------------------------------------------------
// CONTACTS  (lista recebida externamente, sem Redux)
// ---------------------------------------------------------
export const useContactsHook = (contactsList: any[] = []) => {
  // contacts vêm diretamente da prop
  const contacts = contactsList ?? [];

  // Divide em grupos (A, B, C…)
  const categorizedContacts = useMemo(() => {
    if (!contacts || contacts.length === 0) return [];
    return divideByKey("firstName", contacts);
  }, [contacts]);

  return {
    contacts,
    categorizedContacts,
    totalContacts: categorizedContacts.length,
  };
};

// ---------------------------------------------------------
// CONVERSATION USER TYPE
// ---------------------------------------------------------
export const useConversationUserType = (chatUserDetails: any) => {
  // valor derivado direto, sem state
  const isChannel = !!chatUserDetails?.isChannel;

  return { isChannel };
};
